import { useMemo } from "react";
import { navigateTo } from "../../router";
import { ReplayStepper } from "./components/ReplayStepper";
import { YINSH_REPLAY_FIXTURES } from "./replay-fixtures.generated";
import { buildYinshReplaySnapshots } from "./replay-runner";

interface ReplayScreenProps {
  readonly scenario: string;
}

export function ReplayScreen({ scenario }: ReplayScreenProps) {
  const fixture = YINSH_REPLAY_FIXTURES[scenario] ?? null;
  const snapshots = useMemo(
    () => (fixture ? buildYinshReplaySnapshots(fixture.events) : []),
    [fixture],
  );
  const namesByPlayerId = useMemo(
    () =>
      fixture
        ? Object.fromEntries(
            fixture.players.map((player) => [player.id, player.name]),
          )
        : {},
    [fixture],
  );

  if (!fixture || snapshots.length === 0) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-primary p-6 text-text-primary">
        <section className="max-w-sm rounded-md border border-border-primary bg-surface-secondary p-6 text-center">
          <h1 className="mb-2 font-semibold text-lg">
            리플레이를 찾을 수 없습니다
          </h1>
          <p className="mb-4 text-sm text-text-secondary">{scenario}</p>
          <button
            type="button"
            className="rounded-md bg-accent-blue px-4 py-2 font-semibold text-sm text-white"
            onClick={() => navigateTo("/")}
          >
            닫기
          </button>
        </section>
      </div>
    );
  }

  const [white, black] = fixture.players;

  return (
    <ReplayStepper
      snapshots={snapshots}
      whiteName={white?.name ?? "WHITE"}
      blackName={black?.name ?? "BLACK"}
      namesByPlayerId={namesByPlayerId}
      syncUrl={true}
    />
  );
}
